// extracted by mini-css-extract-plugin
export var content = "TextSectionWithList-module--content--18ef1";
export var contentWrapper = "TextSectionWithList-module--contentWrapper--f0111";
export var wrapper = "TextSectionWithList-module--wrapper--e515c";